/**
 * Auto-generated Locale Data File for bn-IN.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 70,
    bcp47Tag: 'bn-IN',
    name: 'Bengali',
    localizedName: 'বাংলা',
    localizedNameList: [
        {
            id: 4,
            name: 'ইংরেজি',
        },
        {
            id: 67,
            name: 'ইংরেজি (অস্ট্রেলিয়া)',
        },
        {
            id: 66,
            name: 'ইংরেজি (কানাডা)',
        },
        {
            id: 59,
            name: 'ইংরেজি (যুক্তরাজ্য)',
        },
        {
            id: 16,
            name: 'ইতালিয়',
        },
        {
            id: 24,
            name: 'ওলন্দাজ',
        },
        {
            id: 55,
            name: 'কোরিয়ান',
        },
        {
            id: 6,
            name: 'চীনা (undefined)',
        },
        {
            id: 63,
            name: 'চীনা (undefined)',
        },
        {
            id: 19,
            name: 'জাপানি',
        },
        {
            id: 18,
            name: 'জার্মান',
        },
        {
            id: 68,
            name: 'ডেনিশ',
        },
        {
            id: 49,
            name: 'তুর্কী',
        },
        {
            id: 69,
            name: 'নরওয়েজিয়ান বোকমাল',
        },
        {
            id: 14,
            name: 'পর্তুগীজ',
        },
        {
            id: 30,
            name: 'পোলিশ',
        },
        {
            id: 21,
            name: 'ফরাসি',
        },
        {
            id: 65,
            name: 'ফরাসি (কানাডা)',
        },
        {
            id: 61,
            name: 'ফিনিশ',
        },
        {
            id: 70,
            name: 'বাংলা',
        },
        {
            id: 8,
            name: 'রুশ',
        },
        {
            id: 57,
            name: 'সুইডিশ',
        },
        {
            id: 10,
            name: 'স্প্যানিশ',
        },
        {
            id: 72,
            name: 'স্প্যানিশ (লাতিন আমেরিকা)',
        },
        {
            id: 71,
            name: 'হিন্দি',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number} হাজার',
        },
        {
            digits: 2,
            msg: '{count, number} হাজার',
        },
        {
            digits: 1,
            msg: '{count, number} লাখ',
        },
        {
            digits: 2,
            msg: '{count, number} লাখ',
        },
        {
            digits: 1,
            msg: '{count, number} কোটি',
        },
        {
            digits: 2,
            msg: '{count, number} কোটি',
        },
        {
            digits: 3,
            msg: '{count, number} কোটি',
        },
        {
            digits: 4,
            msg: '{count, number} কোটি',
        },
        {
            digits: 5,
            msg: '{count, number} কোটি',
        },
        {
            digits: 1,
            msg: '{count, number} লাখ কোটি',
        },
        {
            digits: 2,
            msg: '{count, number} লাখ কোটি',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number} হা',
        },
        {
            digits: 2,
            msg: '{count, number} হা',
        },
        {
            digits: 1,
            msg: '{count, number} লা',
        },
        {
            digits: 2,
            msg: '{count, number} লা',
        },
        {
            digits: 1,
            msg: '{count, number} কো',
        },
        {
            digits: 2,
            msg: '{count, number} কো',
        },
        {
            digits: 3,
            msg: '{count, number} কো',
        },
        {
            digits: 2,
            msg: '{count, plural, other {#শত কো} one {# শত কো}}',
        },
        {
            digits: 3,
            msg: '{count, number}কো',
        },
        {
            digits: 1,
            msg: '{count, number} লা.কো.',
        },
        {
            digits: 2,
            msg: '{count, number} লা.কো.',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 কিরিতিমাতি +14',
        nameLocalized: 'কিরিতিমাতি',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 আপিয়া +13/+14',
        nameLocalized: 'আপিয়া',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 টোঙ্গাটাপু +13/+14',
        nameLocalized: 'টোঙ্গাটাপু',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 ফ্যাকাওফো +13',
        nameLocalized: 'ফ্যাকাওফো',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 চ্যাঠাম +1245/+1345',
        nameLocalized: 'চ্যাঠাম',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 অকল্যান্ড NZST',
        nameLocalized: 'অকল্যান্ড',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 অ্যানাডির +12',
        nameLocalized: 'অ্যানাডির',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 ওয়েক +12',
        nameLocalized: 'ওয়েক',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 ওলিস +12',
        nameLocalized: 'ওলিস',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 কামচাটকা +12',
        nameLocalized: 'কামচাটকা',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 কোয়াজালেইন +12',
        nameLocalized: 'কোয়াজালেইন',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 টারাওয়া +12',
        nameLocalized: 'টারাওয়া',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 নাউরু +12',
        nameLocalized: 'নাউরু',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 ফিজি +12/+13',
        nameLocalized: 'ফিজি',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 ফুনাফুটি +12',
        nameLocalized: 'ফুনাফুটি',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 মাজুরো +12',
        nameLocalized: 'মাজুরো',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 ম্যাকমুর্ডো NZST',
        nameLocalized: 'ম্যাকমুর্ডো',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 ইফাতে +11/+12',
        nameLocalized: 'ইফাতে',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 কোসরায় +11',
        nameLocalized: 'কোসরায়',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 গোয়াদালকুনাল +11',
        nameLocalized: 'গোয়াদালকুনাল',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 নরফক +11/+12',
        nameLocalized: 'নরফক',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 নুমিয়া +11/+12',
        nameLocalized: 'নুমিয়া',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 পোনাপে +11',
        nameLocalized: 'পোনাপে',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 ম্যাগাডান +11',
        nameLocalized: 'ম্যাগাডান',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 সাখালিন +11',
        nameLocalized: 'সাখালিন',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 লর্ড হাও +1030/+11',
        nameLocalized: 'লর্ড হাও',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 গুয়াম ChST',
        nameLocalized: 'গুয়াম',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 চুক +10',
        nameLocalized: 'চুক',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 ডুমন্ট ডি’উরভিল +10',
        nameLocalized: 'ডুমন্ট ডি’উরভিল',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 পোর্ট মৌরজবি +10',
        nameLocalized: 'পোর্ট মৌরজবি',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 ব্রিসবেন AEST',
        nameLocalized: 'ব্রিসবেন',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 ভ্লাদিভস্তোক +10',
        nameLocalized: 'ভ্লাদিভস্তোক',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 মেলবোর্ন AEST',
        nameLocalized: 'মেলবোর্ন',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 লিনডেম্যান AEST',
        nameLocalized: 'লিনডেম্যান',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 সাইপান ChST',
        nameLocalized: 'সাইপান',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 সিডনি AEST',
        nameLocalized: 'সিডনি',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 হোবার্ট AEST',
        nameLocalized: 'হোবার্ট',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 এ্যাডেলেইড ACST',
        nameLocalized: 'এ্যাডেলেইড',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 ডারউইন ACST',
        nameLocalized: 'ডারউইন',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 ব্রোকেন হিল ACST',
        nameLocalized: 'ব্রোকেন হিল',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 ইয়াকুটস্ক +09',
        nameLocalized: 'ইয়াকুটস্ক',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 জয়াপুরা WIT',
        nameLocalized: 'জয়াপুরা',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 টোকিও JST',
        nameLocalized: 'টোকিও',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 দিলি +09',
        nameLocalized: 'দিলি',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 পালাউ +09',
        nameLocalized: 'পালাউ',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 পিয়ংইয়ং KST',
        nameLocalized: 'পিয়ংইয়ং',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 সিওল KST',
        nameLocalized: 'সিওল',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 ইউক্লা +0845/+0945',
        nameLocalized: 'ইউক্লা',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 ইরকুটস্ক +08',
        nameLocalized: 'ইরকুটস্ক',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 উলানবাতার +08/+09',
        nameLocalized: 'উলানবাতার',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 কুচিং +08',
        nameLocalized: 'কুচিং',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 কুয়ালালামপুর +08',
        nameLocalized: 'কুয়ালালামপুর',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 কেইসি +08',
        nameLocalized: 'কেইসি',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 চোইবাল্‌স্যান +08/+09',
        nameLocalized: 'চোইবাল্‌স্যান',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 তাইপেই CST',
        nameLocalized: 'তাইপেই',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 পার্থ AWST',
        nameLocalized: 'পার্থ',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 ব্রুনেই +08',
        nameLocalized: 'ব্রুনেই',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 মাকাসসার WITA',
        nameLocalized: 'মাকাসসার',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 ম্যাকাও CST',
        nameLocalized: 'ম্যাকাও',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 ম্যানিলা PST',
        nameLocalized: 'ম্যানিলা',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 সাংহাই CST',
        nameLocalized: 'সাংহাই',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 সিঙ্গাপুর +08',
        nameLocalized: 'সিঙ্গাপুর',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 হং কং HKST',
        nameLocalized: 'হং কং',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 ক্রাসনোইয়ার্স্ক +07',
        nameLocalized: 'ক্রাসনোইয়ার্স্ক',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 ক্রিসমাস +07',
        nameLocalized: 'ক্রিসমাস',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 জাকার্তা WIB',
        nameLocalized: 'জাকার্তা',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 ডেভিস +07',
        nameLocalized: 'ডেভিস',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 নভোসিবির্স্ক +07',
        nameLocalized: 'নভোসিবির্স্ক',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 নম পেন +07',
        nameLocalized: 'নম পেন',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 পন্টিয়ান্যাক WIB',
        nameLocalized: 'পন্টিয়ান্যাক',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 ব্যাংকক +07',
        nameLocalized: 'ব্যাংকক',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 ভিয়েনতায়েন +07',
        nameLocalized: 'ভিয়েনতায়েন',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 হো চি মিন শহর +07',
        nameLocalized: 'হো চি মিন শহর',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 হোভ্ড +07/+08',
        nameLocalized: 'হোভ্ড',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 কোকোস +0630',
        nameLocalized: 'কোকোস',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 উরুমকি +06',
        nameLocalized: 'উরুমকি',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 ওম্স্ক +06',
        nameLocalized: 'ওম্স্ক',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 ছাগোস +06',
        nameLocalized: 'ছাগোস',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 ঢাকা +06/+07',
        nameLocalized: 'ঢাকা',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 থিম্ফু +06',
        nameLocalized: 'থিম্ফু',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 বিশকেক +06',
        nameLocalized: 'বিশকেক',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 কলম্বো +0530',
        nameLocalized: 'কলম্বো',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 আকটাউ +05',
        nameLocalized: 'আকটাউ',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 আকটোবে +05',
        nameLocalized: 'আকটোবে',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 আলমাটি +05',
        nameLocalized: 'আলমাটি',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 আশগাবাত +05',
        nameLocalized: 'আশগাবাত',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 ইয়েকাটেরিনবার্গ +05',
        nameLocalized: 'ইয়েকাটেরিনবার্গ',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 ওরাল +05',
        nameLocalized: 'ওরাল',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 করাচি PKST',
        nameLocalized: 'করাচি',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 কার্গুলেন +05',
        nameLocalized: 'কার্গুলেন',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 কিজিলর্ডা +05',
        nameLocalized: 'কিজিলর্ডা',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 তাসখন্দ +05',
        nameLocalized: 'তাসখন্দ',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 দুশানবে +05',
        nameLocalized: 'দুশানবে',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 ভস্টোক +05',
        nameLocalized: 'ভস্টোক',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 মসোন +05',
        nameLocalized: 'মসোন',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 মালদ্বীপ +05',
        nameLocalized: 'মালদ্বীপ',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 সমরখন্দ +05',
        nameLocalized: 'সমরখন্দ',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 কাবুল +0430',
        nameLocalized: 'কাবুল',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 ইয়েরাভান +04/+05',
        nameLocalized: 'ইয়েরাভান',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 দুবাই +04',
        nameLocalized: 'দুবাই',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 বাকু +04/+05',
        nameLocalized: 'বাকু',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 মরিশাস +04/+05',
        nameLocalized: 'মরিশাস',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 মাসকট +04',
        nameLocalized: 'মাসকট',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 মাহে +04',
        nameLocalized: 'মাহে',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 রিইউনিয়ন +04',
        nameLocalized: 'রিইউনিয়ন',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 সামারা +04',
        nameLocalized: 'সামারা',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 সিবিলিশি +04',
        nameLocalized: 'সিবিলিশি',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 তেহেরান +0330/+0430',
        nameLocalized: 'তেহেরান',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 অ্যাসমারাহু EAT',
        nameLocalized: 'অ্যাসমারাহু',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 আদ্দিস আবাবা EAT',
        nameLocalized: 'আদ্দিস আবাবা',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 আন্তুনানারিভো EAT',
        nameLocalized: 'আন্তুনানারিভো',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 আম্মান +03',
        nameLocalized: 'আম্মান',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 আহদেন +03',
        nameLocalized: 'আহদেন',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 ইস্তানবুল +03',
        nameLocalized: 'ইস্তানবুল',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 কাতার +03',
        nameLocalized: 'কাতার',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 কামপালা EAT',
        nameLocalized: 'কামপালা',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 কুয়েত +03',
        nameLocalized: 'কুয়েত',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 কোমোরো EAT',
        nameLocalized: 'কোমোরো',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 জিবুটি EAT',
        nameLocalized: 'জিবুটি',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 দামাস্কাস +03',
        nameLocalized: 'দামাস্কাস',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 দার এস সালাম EAT',
        nameLocalized: 'দার এস সালাম',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 নাইরোবি EAT',
        nameLocalized: 'নাইরোবি',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 বাগদাদ +03/+04',
        nameLocalized: 'বাগদাদ',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 বাহারিন +03',
        nameLocalized: 'বাহারিন',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 ভোল্গোগ্রাদ MSK',
        nameLocalized: 'ভোল্গোগ্রাদ',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 মস্কো MSK',
        nameLocalized: 'মস্কো',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 মাওগাদিসু EAT',
        nameLocalized: 'মাওগাদিসু',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 মায়োতো EAT',
        nameLocalized: 'মায়োতো',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 মিন্সক +03',
        nameLocalized: 'মিন্সক',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 রিয়াধ +03',
        nameLocalized: 'রিয়াধ',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 সিওয়া +03',
        nameLocalized: 'সিওয়া',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 সিমফেরোপোল MSK',
        nameLocalized: 'সিমফেরোপোল',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 অমবাবান SAST',
        nameLocalized: 'অমবাবান',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 উইনধোক WAT',
        nameLocalized: 'উইনধোক',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 এথেন্স EET',
        nameLocalized: 'এথেন্স',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 কায়রো EET',
        nameLocalized: 'কায়রো',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 কালিনিঙগ্রাড EET',
        nameLocalized: 'কালিনিঙগ্রাড',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 কিগালি CAT',
        nameLocalized: 'কিগালি',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 কিয়েভ EET',
        nameLocalized: 'কিয়েভ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 কিসিনাহু EET',
        nameLocalized: 'কিসিনাহু',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 খার্তুম CAT',
        nameLocalized: 'খার্তুম',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 গাজা EET',
        nameLocalized: 'গাজা',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 গ্যাবুরনি CAT',
        nameLocalized: 'গ্যাবুরনি',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 জেরুজালেম IST',
        nameLocalized: 'জেরুজালেম',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 জোহানেসবার্গ SAST',
        nameLocalized: 'জোহানেসবার্গ',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 তাহলিন EET',
        nameLocalized: 'তাহলিন',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 ত্রিপোলি EET',
        nameLocalized: 'ত্রিপোলি',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 নিকোসিয়া EET',
        nameLocalized: 'নিকোসিয়া',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 বুখারেস্ট EET',
        nameLocalized: 'বুখারেস্ট',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 বুজুমবুরহু CAT',
        nameLocalized: 'বুজুমবুরহু',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 বেইরুট EET',
        nameLocalized: 'বেইরুট',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 ব্ল্যানটায়ের CAT',
        nameLocalized: 'ব্ল্যানটায়ের',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 ভিলনিওস EET',
        nameLocalized: 'ভিলনিওস',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 মরিয়েহামেন EET',
        nameLocalized: 'মরিয়েহামেন',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 মাপুতো CAT',
        nameLocalized: 'মাপুতো',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 মাহসুরু SAST',
        nameLocalized: 'মাহসুরু',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 রিগা EET',
        nameLocalized: 'রিগা',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 লুবুম্বাশি CAT',
        nameLocalized: 'লুবুম্বাশি',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 লুসাকা CAT',
        nameLocalized: 'লুসাকা',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 সোফিয়া EET',
        nameLocalized: 'সোফিয়া',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 হারারে CAT',
        nameLocalized: 'হারারে',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 হেলসিঙ্কি EET',
        nameLocalized: 'হেলসিঙ্কি',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 অসলো CET',
        nameLocalized: 'অসলো',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 অ্যান্ডোরা CET',
        nameLocalized: 'অ্যান্ডোরা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 আমস্টারডাম CET',
        nameLocalized: 'আমস্টারডাম',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 আলজিয়ার্স CET',
        nameLocalized: 'আলজিয়ার্স',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 এনজমেনা WAT',
        nameLocalized: 'এনজমেনা',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 এল আহইউন +01/+00',
        nameLocalized: 'এল আহইউন',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 ওয়ারশ CET',
        nameLocalized: 'ওয়ারশ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 কাসাব্লাঙ্কা +01/+00',
        nameLocalized: 'কাসাব্লাঙ্কা',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 কিনশাসা WAT',
        nameLocalized: 'কিনশাসা',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 কোপেনহেগেন CET',
        nameLocalized: 'কোপেনহেগেন',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 জাগ্রেব CET',
        nameLocalized: 'জাগ্রেব',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 জিব্রাল্টার CET',
        nameLocalized: 'জিব্রাল্টার',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 জুরিখ CET',
        nameLocalized: 'জুরিখ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 টিউনিস CEST',
        nameLocalized: 'টিউনিস',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 ডাবলিন IST/GMT',
        nameLocalized: 'ডাবলিন',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 ডোয়ালা WAT',
        nameLocalized: 'ডোয়ালা',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 তিরানা CET',
        nameLocalized: 'তিরানা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 নিয়ামে WAT',
        nameLocalized: 'নিয়ামে',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 পডগরিত্সা CET',
        nameLocalized: 'পডগরিত্সা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 পোর্টো-নোভো WAT',
        nameLocalized: 'পোর্টো-নোভো',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 প্যারিস CET',
        nameLocalized: 'প্যারিস',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 প্রাগ CET',
        nameLocalized: 'প্রাগ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 বাঙ্গুই WAT',
        nameLocalized: 'বাঙ্গুই',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 বার্লিন CET',
        nameLocalized: 'বার্লিন',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 বুডাপেস্ট CET',
        nameLocalized: 'বুডাপেস্ট',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 বেলগ্রেড CET',
        nameLocalized: 'বেলগ্রেড',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 ব্রাজাভিলি WAT',
        nameLocalized: 'ব্রাজাভিলি',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 ব্রাতিস্লাভা CET',
        nameLocalized: 'ব্রাতিস্লাভা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 ব্রাসেলস CET',
        nameLocalized: 'ব্রাসেলস',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 ভাটিকান CET',
        nameLocalized: 'ভাটিকান',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 ভাদুজ CET',
        nameLocalized: 'ভাদুজ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 ভিয়েনা CET',
        nameLocalized: 'ভিয়েনা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 মাদ্রিদ CET',
        nameLocalized: 'মাদ্রিদ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 মালাবো WAT',
        nameLocalized: 'মালাবো',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 মাল্টা CET',
        nameLocalized: 'মাল্টা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 মোনাকো CET',
        nameLocalized: 'মোনাকো',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 রোম CET',
        nameLocalized: 'রোম',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 লঞ্জিয়বিয়েঁন CET',
        nameLocalized: 'লঞ্জিয়বিয়েঁন',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 লাগোস WAT',
        nameLocalized: 'লাগোস',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 লিব্রুভিল WAT',
        nameLocalized: 'লিব্রুভিল',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 লুক্সেমবার্গ CET',
        nameLocalized: 'লুক্সেমবার্গ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 লুবলিয়ানা CET',
        nameLocalized: 'লুবলিয়ানা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 লোয়ান্ডা WAT',
        nameLocalized: 'লোয়ান্ডা',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 সান মেরিনো CET',
        nameLocalized: 'সান মেরিনো',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 সারাজিভো CET',
        nameLocalized: 'সারাজিভো',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 সেউটা CET',
        nameLocalized: 'সেউটা',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 স্কপয়ে CET',
        nameLocalized: 'স্কপয়ে',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 স্টকহোম CET',
        nameLocalized: 'স্টকহোম',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 আইল অফ ম্যান GMT/BST',
        nameLocalized: 'আইল অফ ম্যান',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 আক্রা GMT',
        nameLocalized: 'আক্রা',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 আবিদজান GMT',
        nameLocalized: 'আবিদজান',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 এন্ডারবারি -00',
        nameLocalized: 'এন্ডারবারি',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 ওয়াহগুডোগু GMT',
        nameLocalized: 'ওয়াহগুডোগু',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 কনাক্রি GMT',
        nameLocalized: 'কনাক্রি',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 কাঠমান্ডু UTC',
        nameLocalized: 'কাঠমান্ডু',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 কানেরি WET',
        nameLocalized: 'কানেরি',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 কোলকাতা UTC',
        nameLocalized: 'কোলকাতা',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 গুয়ার্নসি GMT/BST',
        nameLocalized: 'গুয়ার্নসি',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 জার্সি GMT/BST',
        nameLocalized: 'জার্সি',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 ডাকার GMT',
        nameLocalized: 'ডাকার',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 ডানমার্কশ্যাভন GMT',
        nameLocalized: 'ডানমার্কশ্যাভন',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 নোয়াকশট GMT',
        nameLocalized: 'নোয়াকশট',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 ফ্যারো UTC',
        nameLocalized: 'ফ্যারো',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 ফ্রীটাউন GMT',
        nameLocalized: 'ফ্রীটাউন',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 বাঞ্জুল GMT',
        nameLocalized: 'বাঞ্জুল',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 বাম্যাকো GMT',
        nameLocalized: 'বাম্যাকো',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 বিসোউ GMT',
        nameLocalized: 'বিসোউ',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 মনরোভিয়া GMT',
        nameLocalized: 'মনরোভিয়া',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 মাডেইরা WET',
        nameLocalized: 'মাডেইরা',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 রিকজাভিক GMT',
        nameLocalized: 'রিকজাভিক',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 রেঙ্গুন UTC',
        nameLocalized: 'রেঙ্গুন',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 লন্ডন GMT/BST',
        nameLocalized: 'লন্ডন',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 লিসবন WET',
        nameLocalized: 'লিসবন',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 লোমে GMT',
        nameLocalized: 'লোমে',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 সাও টোম GMT',
        nameLocalized: 'সাও টোম',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 সেন্ট. হেলেনা GMT',
        nameLocalized: 'সেন্ট. হেলেনা',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 আজোরেস -01/+00',
        nameLocalized: 'আজোরেস',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 কেপ ভার্দ -01',
        nameLocalized: 'কেপ ভার্দ',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 ইট্টকুয়োরটুরমিট -02/-01',
        nameLocalized: 'ইট্টকুয়োরটুরমিট',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 দক্ষিণ জর্জিয়া -02',
        nameLocalized: 'দক্ষিণ জর্জিয়া',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 নরোন্‌হা -02',
        nameLocalized: 'নরোন্‌হা',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 সেন্ট জন্স NST',
        nameLocalized: 'সেন্ট জন্স',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 আরাগুয়াইনা -03',
        nameLocalized: 'আরাগুয়াইনা',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 উশুয়াইয়া -03',
        nameLocalized: 'উশুয়াইয়া',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 কর্ডোবা -03/-02',
        nameLocalized: 'কর্ডোবা',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 কাহেন -03',
        nameLocalized: 'কাহেন',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 ক্যাটামার্কা -03',
        nameLocalized: 'ক্যাটামার্কা',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 জুজুই -03',
        nameLocalized: 'জুজুই',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 টুকুমান -03/-02',
        nameLocalized: 'টুকুমান',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 নুক -03/-02',
        nameLocalized: 'নুক',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 পালমার -03',
        nameLocalized: 'পালমার',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 প্যারামেরিবো -03',
        nameLocalized: 'প্যারামেরিবো',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 ফোর্টালেজা -03',
        nameLocalized: 'ফোর্টালেজা',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 বাহিয়া -03',
        nameLocalized: 'বাহিয়া',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 বুয়েনোস আয়েরেস -03/-02',
        nameLocalized: 'বুয়েনোস আয়েরেস',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 বেলেম -03',
        nameLocalized: 'বেলেম',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 মন্টেভিডিও -03/-02',
        nameLocalized: 'মন্টেভিডিও',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 মাসেয়ো -03',
        nameLocalized: 'মাসেয়ো',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 মিকুলন -03/-02',
        nameLocalized: 'মিকুলন',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 মেন্ডোজা -03',
        nameLocalized: 'মেন্ডোজা',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 রথেরা -03',
        nameLocalized: 'রথেরা',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 রিও গায়েগোস -03',
        nameLocalized: 'রিও গায়েগোস',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 রেসিফে -03',
        nameLocalized: 'রেসিফে',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 লা রিওহা -03',
        nameLocalized: 'লা রিওহা',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 সাও পাউলো -03/-02',
        nameLocalized: 'সাও পাউলো',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 সান জুয়ান -03',
        nameLocalized: 'সান জুয়ান',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 স্টানলী -03',
        nameLocalized: 'স্টানলী',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 অ্যাঙ্গুইলা AST',
        nameLocalized: 'অ্যাঙ্গুইলা',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 অ্যান্টিগুয়া AST',
        nameLocalized: 'অ্যান্টিগুয়া',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 আসুনসিয়ন -04/-03',
        nameLocalized: 'আসুনসিয়ন',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 এরুবা AST',
        nameLocalized: 'এরুবা',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 কাম্পো গ্রান্ডে -04/-03',
        nameLocalized: 'কাম্পো গ্রান্ডে',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 কুইয়াবা -04/-03',
        nameLocalized: 'কুইয়াবা',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 কুরাসাও AST',
        nameLocalized: 'কুরাসাও',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 ক্যারাকাস -04',
        nameLocalized: 'ক্যারাকাস',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 গায়ানা -04',
        nameLocalized: 'গায়ানা',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 গুয়াদেলোপ AST',
        nameLocalized: 'গুয়াদেলোপ',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 গুস বে AST',
        nameLocalized: 'গুস বে',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 গ্রেনাডা AST',
        nameLocalized: 'গ্রেনাডা',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 গ্লাস বে AST',
        nameLocalized: 'গ্লাস বে',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 টরটোলা AST',
        nameLocalized: 'টরটোলা',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 ডোমিনিকা AST',
        nameLocalized: 'ডোমিনিকা',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 থুলি AST',
        nameLocalized: 'থুলি',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 পুয়ের্তো রিকো AST',
        nameLocalized: 'পুয়ের্তো রিকো',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 পোর্ট অফ স্পেন AST',
        nameLocalized: 'পোর্ট অফ স্পেন',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 পোর্তো ভেল্‌হো -04',
        nameLocalized: 'পোর্তো ভেল্‌হো',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 বারমুডা AST',
        nameLocalized: 'বারমুডা',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 বার্বাডোজ AST',
        nameLocalized: 'বার্বাডোজ',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 বোয়া ভিস্তা -04',
        nameLocalized: 'বোয়া ভিস্তা',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 ব্লাঙ্ক-সাব্লোন AST',
        nameLocalized: 'ব্লাঙ্ক-সাব্লোন',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 মঙ্কটোন AST',
        nameLocalized: 'মঙ্কটোন',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 মন্তসেরাত AST',
        nameLocalized: 'মন্তসেরাত',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 মানাউস -04',
        nameLocalized: 'মানাউস',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 মারটিনিক AST',
        nameLocalized: 'মারটিনিক',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 লা পাজ -04',
        nameLocalized: 'লা পাজ',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 সান্টিয়াগো -04/-03',
        nameLocalized: 'সান্টিয়াগো',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 সেন্ট. কিটস AST',
        nameLocalized: 'সেন্ট. কিটস',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 সেন্ট. থমাস AST',
        nameLocalized: 'সেন্ট. থমাস',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 সেন্ট. ভিনসেন্ট AST',
        nameLocalized: 'সেন্ট. ভিনসেন্ট',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 সেন্ট. লুসিয়া AST',
        nameLocalized: 'সেন্ট. লুসিয়া',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 স্যান্টো ডোমিংগো AST',
        nameLocalized: 'স্যান্টো ডোমিংগো',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 হ্যালিফ্যাক্স AST',
        nameLocalized: 'হ্যালিফ্যাক্স',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 আইরুনেপে -05',
        nameLocalized: 'আইরুনেপে',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 আটিকোকান EST',
        nameLocalized: 'আটিকোকান',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 ইকুয়ালুইট EST',
        nameLocalized: 'ইকুয়ালুইট',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 ইন্ডিয়ানাপোলিস EST',
        nameLocalized: 'ইন্ডিয়ানাপোলিস',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 উইনাম্যাক, ইন্ডিয়ানা EST',
        nameLocalized: 'উইনাম্যাক, ইন্ডিয়ানা',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 কামেন EST',
        nameLocalized: 'কামেন',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 ক্যানকুন EST',
        nameLocalized: 'ক্যানকুন',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 গোয়াইয়াকিল -05/-04',
        nameLocalized: 'গোয়াইয়াকিল',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 গ্র্যান্ড তুর্ক EST',
        nameLocalized: 'গ্র্যান্ড তুর্ক',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 জামাইকা EST',
        nameLocalized: 'জামাইকা',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 টোরন্টো EST',
        nameLocalized: 'টোরন্টো',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 ডেট্রোইট EST',
        nameLocalized: 'ডেট্রোইট',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 নাসাউ EST',
        nameLocalized: 'নাসাউ',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 নিউইয়র্ক EST',
        nameLocalized: 'নিউইয়র্ক',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 পানামা EST',
        nameLocalized: 'পানামা',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 পিটারর্সবার্গ, ইন্ডিয়ানা EST',
        nameLocalized: 'পিটারর্সবার্গ, ইন্ডিয়ানা',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 পোর্ট-অহ-প্রিন্স EST',
        nameLocalized: 'পোর্ট-অহ-প্রিন্স',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 বোগোটা -05/-04',
        nameLocalized: 'বোগোটা',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 ভিনসেন্নেস, ইন্ডিয়ানা EST',
        nameLocalized: 'ভিনসেন্নেস, ইন্ডিয়ানা',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 ভেভেয়, ইন্ডিয়ানা EST',
        nameLocalized: 'ভেভেয়, ইন্ডিয়ানা',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 মন্টিচেলো, কেন্টাকি EST',
        nameLocalized: 'মন্টিচেলো, কেন্টাকি',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 মারেঙ্গো, ইন্ডিয়ানা EST',
        nameLocalized: 'মারেঙ্গো, ইন্ডিয়ানা',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 রিও ব্রাঙ্কো -05',
        nameLocalized: 'রিও ব্রাঙ্কো',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 লিমা -05/-04',
        nameLocalized: 'লিমা',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 লুইসভিল EST',
        nameLocalized: 'লুইসভিল',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 হাভানা CST',
        nameLocalized: 'হাভানা',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 ইস্টার -06/-05',
        nameLocalized: 'ইস্টার',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 উইনিপেগ CST',
        nameLocalized: 'উইনিপেগ',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 এল সালভাদোর CST',
        nameLocalized: 'এল সালভাদোর',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 কোস্টারিকা CST',
        nameLocalized: 'কোস্টারিকা',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 গুয়াতেমালা CST',
        nameLocalized: 'গুয়াতেমালা',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 গ্যালাপ্যাগোস -06/-05',
        nameLocalized: 'গ্যালাপ্যাগোস',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 চিহুয়াহুয়া CST',
        nameLocalized: 'চিহুয়াহুয়া',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 তেগুসিগালপা CST',
        nameLocalized: 'তেগুসিগালপা',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 নক্স, ইন্ডিয়ানা CST',
        nameLocalized: 'নক্স, ইন্ডিয়ানা',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 নিউ সালেম, উত্তর ডাকোটা CST',
        nameLocalized: 'নিউ সালেম, উত্তর ডাকোটা',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 বেলিজ CST',
        nameLocalized: 'বেলিজ',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 মধ্য, উত্তর ডাকোটা CST',
        nameLocalized: 'মধ্য, উত্তর ডাকোটা',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 মন্টেরি CST',
        nameLocalized: 'মন্টেরি',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 মানাগুয়া CST',
        nameLocalized: 'মানাগুয়া',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 মেক্সিকো সিটি CST',
        nameLocalized: 'মেক্সিকো সিটি',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 মেনোমিনি CST',
        nameLocalized: 'মেনোমিনি',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 মেরিডা CST',
        nameLocalized: 'মেরিডা',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 রেজিনা CST',
        nameLocalized: 'রেজিনা',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 রেসোলুট CST',
        nameLocalized: 'রেসোলুট',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 র‍্যাঙ্কিন ইনলেট CST',
        nameLocalized: 'র‍্যাঙ্কিন ইনলেট',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 শিকাগো CST',
        nameLocalized: 'শিকাগো',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 সুইফ্ট কারেন্ট CST',
        nameLocalized: 'সুইফ্ট কারেন্ট',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 ইনুভ্যাক MST',
        nameLocalized: 'ইনুভ্যাক',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 এডমন্টোন MST',
        nameLocalized: 'এডমন্টোন',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 কেমব্রিজ বে MST',
        nameLocalized: 'কেমব্রিজ বে',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 ডসোন MST',
        nameLocalized: 'ডসোন',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 ডসোন ক্রিক MST',
        nameLocalized: 'ডসোন ক্রিক',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 ডেনভার MST',
        nameLocalized: 'ডেনভার',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 ফিনিক্স MST',
        nameLocalized: 'ফিনিক্স',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 বয়জি MST',
        nameLocalized: 'বয়জি',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 মাজাটলান MST',
        nameLocalized: 'মাজাটলান',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 হারমোসিল্লো MST',
        nameLocalized: 'হারমোসিল্লো',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 হোয়াইটহর্স MST',
        nameLocalized: 'হোয়াইটহর্স',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 তিজুয়ানা PST',
        nameLocalized: 'তিজুয়ানা',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 পিটকেয়ার্ন -08',
        nameLocalized: 'পিটকেয়ার্ন',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 ভ্যাঙ্কুভার PST',
        nameLocalized: 'ভ্যাঙ্কুভার',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 লস অ্যাঞ্জেলেস PST',
        nameLocalized: 'লস অ্যাঞ্জেলেস',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 মার্কেসাস -0930',
        nameLocalized: 'মার্কেসাস',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 ইয়াকুটাট AKST',
        nameLocalized: 'ইয়াকুটাট',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 এনকোরেজ AKST',
        nameLocalized: 'এনকোরেজ',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 গাম্বিয়ের -09',
        nameLocalized: 'গাম্বিয়ের',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 জুনো AKST',
        nameLocalized: 'জুনো',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 নোম AKST',
        nameLocalized: 'নোম',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 আডক HST',
        nameLocalized: 'আডক',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 তাহিতি -10',
        nameLocalized: 'তাহিতি',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 রারউহতুঙ্গা -10/-0930',
        nameLocalized: 'রারউহতুঙ্গা',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 হনোলুলু HST',
        nameLocalized: 'হনোলুলু',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 নিউয়ি -11',
        nameLocalized: 'নিউয়ি',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 প্যাগো প্যাগো SST',
        nameLocalized: 'প্যাগো প্যাগো',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 মিডওয়ে SST',
        nameLocalized: 'মিডওয়ে',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 0,
    weekendStart: 0,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: 'রবি',
            mon: 'সোম',
            tue: 'মঙ্গল',
            wed: 'বুধ',
            thu: 'বৃহস্পতি',
            fri: 'শুক্র',
            sat: 'শনি',
        },
        narrow: {
            sun: 'র',
            mon: 'সো',
            tue: 'ম',
            wed: 'বু',
            thu: 'বৃ',
            fri: 'শু',
            sat: 'শ',
        },
        short: {
            sun: 'রঃ',
            mon: 'সোঃ',
            tue: 'মঃ',
            wed: 'বুঃ',
            thu: 'বৃঃ',
            fri: 'শুঃ',
            sat: 'শনি',
        },
        wide: {
            sun: 'রবিবার',
            mon: 'সোমবার',
            tue: 'মঙ্গলবার',
            wed: 'বুধবার',
            thu: 'বৃহস্পতিবার',
            fri: 'শুক্রবার',
            sat: 'শনিবার',
        },
    },
    standAlone: {
        abbreviated: {
            sun: 'রবি',
            mon: 'সোম',
            tue: 'মঙ্গল',
            wed: 'বুধ',
            thu: 'বৃহস্পতি',
            fri: 'শুক্র',
            sat: 'শনি',
        },
        narrow: {
            sun: 'র',
            mon: 'সো',
            tue: 'ম',
            wed: 'বু',
            thu: 'বৃ',
            fri: 'শু',
            sat: 'শ',
        },
        short: {
            sun: 'রঃ',
            mon: 'সোঃ',
            tue: 'মঃ',
            wed: 'বুঃ',
            thu: 'বৃঃ',
            fri: 'শুঃ',
            sat: 'শনি',
        },
        wide: {
            sun: 'রবিবার',
            mon: 'সোমবার',
            tue: 'মঙ্গলবার',
            wed: 'বুধবার',
            thu: 'বৃহস্পতিবার',
            fri: 'শুক্রবার',
            sat: 'শনিবার',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
